<template>
  <div class="unishop-show-modal unishop-show-wrap">
    <div class="unishop-modal">
      <div class="modal-detalle-producto" id="modal-detalle-producto">
          <v-btn absolute fab flat top right class="primary-color display-1" @click="$emit('cerrar')"><v-icon class=" ">close</v-icon></v-btn>
          <section>
            <v-carousel>
              <v-carousel-item
                 v-for="(foto,index) in fotos" :key="index"
                :src="foto"
                 height="800"
                 :continuous="false"
              ></v-carousel-item>
            </v-carousel>
            <div v-if="mostrarBotones" class="py-4 text-info">
              <div class="d-flex justify-space-between align-center grey--text">
                <div class="display-1 no-flex mb-0 text-uppercase primary-color">{{ productAux.modelo }} </div>
                <div class="float-right no-flex headline">Loc. {{ productAux.localizador}}</div>
              </div>
                <p class="headline" > 
                  <span class="text-uppercase">{{ productAux.color }}</span>
                  <span class="float-right" v-if="productAux.ecomercio != null">Cod e-com. {{ productAux.ecomercio }}</span>
                </p>
                <div class="unishop-modal-options">
                  <p class="mb-0 mt-2">Talla </p><strong v-if="medida !== ''" class="unishop-modal-label medida">{{medida}}</strong>
                  <!-- <div class="unishop-select-wrap" title="Talla" >
                    <select name="unishop-option-lenses" v-model="tallaInterna" id="id_work_days">
                        <option v-for="option in productAux.tallas" v-bind:value="option.tallaInterna" :key="option.tallaInterna" @change="getCodigo()">{{ option.talla }}</option>
                    </select> -->
                    <form class="form d-flex justify-content-start">
                        <label class="mr-1 no-flex" v-for="talla in productAux.tallas" :key="talla.id" v-show="hayStock(talla.tallaInterna)">
                          <input type="radio" v-model="tallaInterna" :value="talla.tallaInterna" @change="getPrecCodStock"><span>{{ talla.talla }}</span>
                        </label>
                    </form>
                  <!-- </div> -->
            </div> 
                <div class="d-flex justify-space-between align-end flex-wrap">
                  <!-- <div class="unishop-modal-options mr-2 no-flex" v-show="colores.length > 1" :class="{ collapsible: colores.length > 3 }" @click="toggleColores()"> -->
                  <div class="unishop-modal-options mr-2" v-show="colores.length > 1">
                        <p class="mb-0 mt-2">Colores </p>
                        <!-- <button class="accordion" v-if="colores.length > 3" :class="{ active: mostrarColores }"></button>    -->
                        <!-- <form class="form cf d-flex" v-show="mostrarColores || colores.length <= 3"> -->
                        <form class="form cf d-flex">
                          <section class="plan cf mr-1 d-flex flex-wrap">
                            <label class="mr-1 mb-1 no-flex" v-for="color in colores" :key="color.id" v-show="color.color!==productAux.color">
                              <span @click="cambiarArticulo(color)"><img :src="getFotoColores(color)" width="65" height="59"></span>
                            </label>
                          </section>                        
                        </form>
                  </div>
                <!--{{ productAux.descripcion }}-->
               <div class="d-flex no-flex ml-auto price" v-if="precio !== '' && codigoEanActual !== '' && talla !== ''">
                    <!-- <div class="unishop-modal-rating unishop-rating"><span class="unishop-star"></span><span class="unishop-star"></span><span class="unishop-star"></span><span class="unishop-halfstar"></span></div> -->
                  <div id="unishop-item-quantity" class="unishop-modal-quantity ml-2 mr-5 no-flex d-flex align-end mb-3">
                    <div class="unishop-quantity-wrap">
                      <v-btn icon small flat class="ma-0 primary" @click="restar()">
                        <v-icon >
                          remove
                        </v-icon> 
                      </v-btn>
                      <input type="number" name="unishop-item-quantity" class="display-1 " v-model.number="cantidad">
                      <v-btn icon small flat class="ma-0 primary" @click="sumar()">
                          <v-icon>
                            add
                          </v-icon>
                        </v-btn>
                      </div>
                  </div> 
             <div class="no-flex mb-0 d-flex align-end">
                  <v-btn  small fab orange flat v-if="mostrarLikeList" class="ma-3 orange" @click="addToLikeList()"><i :style="[isInLikeList ? {'color' : '#e81a37'} : {'color' : '#fff'}]" class="icon-heart5"></i></v-btn>
                  <!--<v-btn absolute  bottom right flat class="orange guardar white--text" href="#" @click="addToCart()"><v-icon>shopping_cart</v-icon>Añadir al carrito</v-btn>-->
                </div>
                  <h2 class="no-flex mb-0 d-flex align-end">{{ formatMoney(precio) }}</h2>
                </div>
              </div>
                <!-- <div class="unishop-modal-reset"><a href="#" title="Reset all options">Reset</a></div>
                <div class="unishop-modal-summary">
                  <div class="unishop-modal-subtotal"><span>Subtotal:</span> $23 (1 item)</div>
                  <div class="unishop-modal-shipping"><span>Shipping:</span> FREE</div>
                  <div class="unishop-modal-total"><span>TOTAL:</span> $23</div>
                </div> -->
              
                <!-- <div>  
                  <table>
                    <tr>
                      <th>Tienda</th>
                      <th>Unidades</th>
                    </tr>
                    <tr v-for="(element,index) in stock" :key="index">
                      <td>{{element.opid}}</td>
                      <td>{{element.unidades}}</td>
                    </tr>
                  </table> 
                </div>-->
                <div v-if="error"> {{ errorMsj }} </div>
            </div>
          </section>
            <v-btn v-if="precio !== '' && codigoEanActual !== '' && talla !== ''" large absolute fab bottom right flat class="orange guardar white--text" href="#" @click="addToCart()">
            <v-icon>shopping_cart</v-icon>
        </v-btn>
        <div class="scroll">
          <div class="stock">
               <div class="mt-10" v-if="mostrarControlStock">
                <!-- <h5>Control de stock</h5> -->
                <div class="search elevation-1">
                  <v-toolbar flat class="d-flex justify-space-between">
                      <v-toolbar-title class="primary-color">
                        <v-icon class="mr-3 primary-color">person_add</v-icon>
                        Control de stock
                      </v-toolbar-title>
                        <v-btn 
                          icon
                          flat
                          class="primary-color" 
                          @click="mostrarControlStock=false">
                        <!--<img class='btn-footer-izq pointer' src='@/assets/images/Btn-ESC.gif' >-->
                        <!--{{ $t('lang.comun.salir') }}-->
                        <v-icon>close</v-icon>
                      </v-btn>
                  </v-toolbar>
                    <div class="px-5 d-flex align-center justify-space-between">
                        <v-select
                          :read-only="store1RO"
                          item-value="msopuid" 
                          :items="tiendas" 
                          item-text="msopclicode"
                          label="De tienda"
                          v-model="store1"
                          class="m-4"
                          attach/>
    
                      <i class="icon-arrow-right7 mt-15"></i>
                
                        <v-select
                          :read-only="store2RO"
                          label="A tienda"
                          class="mx-4"
                          item-value="msopuid" 
                          :items="tiendas" 
                          item-text="msopclicode"
                          v-model="store2"
                          attach />
                    <div class="d-flex no-flex ml-auto align-center">
                      <v-btn icon small flat class="text-right no-flex primary">
                        <v-icon class="mt-15 white--text"  @click="sumarStock">add</v-icon>
                      </v-btn>
                        <v-text-field class="no-flex" v-model="movStock" placeholder="Unidades"></v-text-field>
                      <v-btn icon small flat class="no-flex primary">
                        <v-icon class=" mt-15 white--text" @click="restarStock">remove</v-icon>
                      </v-btn>
                    </div>
                  </div>
                   <v-btn absolute fab bottom right flat class="orange" href="#" @click="guardarControlStock()">
                      <v-icon class="white--text">send</v-icon>
                   </v-btn>
                 
                </div>
              </div>
              <v-tabs
               v-if="colores.length > 0"
                :v-model="1"
                fixed-tabs
                background-color="#00639f"
                grow
              >
                <v-tab
                  key="1"
                  @click="stockPorColor = false"
                >
                  Tallas
                </v-tab>
                <v-tab
                  key="2"
                  @click="stockPorColor = true"
                >
                  Colores
                </v-tab>
              </v-tabs>
              <!-- tabla por tallas -->
              <div class="tabla-stock 
              " v-if="!stockPorColor">          
                <div class="table-wrapper tallas">
                  <table>
                    <thead>
                      <tr>
                        <th>Tienda</th>
                        <th v-for="(element,index) in tallas" :key="index" v-show="element.bloqueado ==='N'" >{{element.talla}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(element1,index1) in ops" :key="index1">
                        <td>{{element1}}</td>
                        <td v-for="(element,index2) in tallas" v-show="element.bloqueado ==='N'" :key="index2" @click="abrirControlStock(element1, stock[index2][index1])">{{stock[index2][index1]}}</td>
                      </tr>
                    </tbody>
                    <tr class="total">
                        <td>Total</td>
                        <td v-for="(element,index) in totalTallas" :key="index" v-show="element.bloqueado ==='N'">{{element.cantidad}}</td>
                    </tr>
                  </table>
                </div>
              </div>
              <!-- tabla por colores -->
              <div class="tabla-stock " v-else>          
                <div class="table-wrapper color">
                  <table>
                    <thead>
                      <tr>
                        <th>Tienda</th>
                        <th v-for="color in colores" :key="color.id">{{color.color}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(element1,index1) in ops" :key="index1">
                        <td>{{element1}}</td>
                        <td v-for="(color,index2) in colores" :key="index2">{{stockColores[index2][index1]}}</td>
                      </tr>
                    </tbody>
                    <tr class="total">
                        <td>Total</td>
                        <td v-for="(element,index) in totalColores" :key="index">{{element}}</td>
                    </tr>
                  </table>
                </div>
              </div>  
            </div>
            <!--  -->
          <div class="text-center mb-5">
            <barcode v-if="codigoEanActual !== ''" :value="codigoEanActual" :options="{ displayValue: true }"></barcode>
          </div>
          <div class="clearfix"></div>
          <div v-if="relacionados.length>0" class="mt-70"> 
            <div class="my-3 mx-4 headline text-center">COMPLETA TU LOOK</div>
            <div class="card-carousel-wrapper ">
              <div class="card-carousel--nav__left" @click="moveCarousel(-1)" :disabled="atHeadOfList"></div>
              <div class="card-carousel">
                <div class="card-carousel--overflow-container">
                  <div class="card-carousel-cards d-flex justify-center" :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')' }">
                    <div class="card-carousel--card" v-for="relacionado in relacionados" :key="relacionado.id" @click="cambiarArticulo(relacionado)">
                      <img :src="getFotoColores(relacionado)"/>
                      <div class="card-carousel--card--footer px-2">
                        <h2 class="primary-color h5 text-truncate text-uppercase mb-0 font-weight-medium">{{relacionado.modelo}}</h2>
                          <p class="d-flex py-2 text-uppercase pb-1"> {{relacionado.color}}
                            <span class="no-flex my-0 h5 ml-auto floar-right font-weight-black"> 
                              {{ getPrecioRelacionado(relacionado) }}
                            </span>
                          </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-carousel--nav__right" @click="moveCarousel(1)" :disabled="atEndOfList"></div>
            </div>
        </div>
      </div>
      </div>  
    </div>
  </div>
</template>
<style scoped>
.splide__pagination{
    bottom: .9em;
}
</style>
<script>
import { TiendaApiService } from '@/api/TiendaApiService'
import { TicketApiService } from '@/api/TicketApiService' 
import { Util } from '@/api/Util'

const tiendaApiService = new TiendaApiService()
const ticketApiService = new TicketApiService()
const util = new Util()

export default {
  name: 'detalleproductAux',
  data () {
    return {
      // opId: this.$store.getters.getIdTienda,
      currentOffset: 0,
      windowSize: 3,
      paginationFactor: 255,
      cantidad: 1,
      tallaInterna: '',
      talla: '',
      fotoDefecto: '',
      fotoSecundaria: '',
      precio: '',
      precios: [],
      codigoEanActual: '',
      codigosEan: [],
      medidas:[],
      medida: '',
      unidadesDisp: 0,
      stock: [[]],
      stockColores: [[]],
      stockReservado: [],
      fotos: [],
      tallas: [],
      totalTallas:[],
      totalColores: [],
      ops : [],
      colores: [],
      relacionados: [],
      error: false,
      errorMsj: '',
      productAux: this.producto,
      mostrarColores: false,
      stockPorColor: false,
      tiendas: this.$store.state.iniOps,
       options: {
        rewind: true,
        arrows: true,
        pagination: true,
        autoplay: true,
      },
      likeList: [],
      isInLikeList: false,
      mostrarLikeList: false,
      mostrarBotones: false,
      mostrarControlStock: false,
      controlStock: 0,
      movStock: 0,
      store1: '', //tienda a la que pides stock
      store2: '', //Tu tienda,
      store1RO: true,
      store2RO: true
    };
  },
  props: {
    producto: Object,
    opId: Number,
  },
  created() {
    if (this.cliente !==null) {
      this.addToHistorial()
    }
    this.getColores()
    this.init()
  },
  mounted () {
    // this.init()
  },
  computed: {
    atEndOfList() {
      return this.currentOffset <= (this.paginationFactor * -1) * (this.relacionados.length - this.windowSize);
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
    cliente () {
      return this.$store.getters.getCliente
    },
  },
  watch:{
    cliente(value) {
      if (value !== null) {
        this.mostrarLikeList = true
      }
    }
  },
  methods: {
    init() {
      if (this.cliente !== null) {
        this.mostrarLikeList = true
      }
      this.store1 = this.tiendas[0].msopuid
      this.store2 = this.tiendas[0].msopuid
      this.currentOffset = 0,
      this.fotos = []
      this.tallaInterna = ''
      this.getLikeList()
      this.getStockReservadoByEansOps()
      //this.getMedidas()
      this.getFotos()
      //this.getStock() 
      //this.getPrecios()
      this.getArticulosRelacionados()
      // this.getPrecCodStock()
      // this.getCodigo()
      
    },
    moveCarousel(direction) {
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
    getArticulosRelacionados(){
       tiendaApiService.getArticulosRelacionados(this.productAux.id)
        .then(data => {
          // util.mostrarEnConsola('tiendaApiService - getArticulosRelacionados', data.length, 'OK')
          // console.log(data)
          this.relacionados = data
        })
        .catch(error => {
          util.mostrarEnConsola('tiendaApiService - getArticulosRelacionados', error, 'ERROR')
        })
    },
    getPrecioRelacionado(producto) {
      let precioAux = ''
      let pass = false
      for (var i = 0; i < producto.tallas.length; i++) {
        if (producto.tallas[i].stocks.length > 0) {
          let stockOp = producto.tallas[i].stocks.find( stock => stock.id.id_op === this.opId )
          if (stockOp) {
            if (stockOp.precio) {
              precioAux = stockOp.precio.precio
              pass = true
            }
          } else {
            for (var x = 0; x < producto.tallas[i].stocks.length; x++) {
              if (producto.tallas[i].stocks[x].precio) {
                precioAux = producto.tallas[i].stocks[x].precio.precio
              }
            }
          }
        }
        if (pass) {
          break
        }
      }
      return util.formatMoney(precioAux)
    },
    getPrecios(){
      tiendaApiService.getPreciosByIdArtandIdOp(this.productAux.id,this.opId)
        .then(data => {
          // util.mostrarEnConsola('tiendaApiService - getPreciosByIdArtandIdOp', data.length, 'OK')
          //console.log(data)
          if (!data) {
            this.$root.$emit('mostrarAlerta', 'No hay precios del artículo en la tienda', 'error')
          }
          this.precios = data 
          this.getPrecCodStock()
        })
        .catch(error => {
          
          util.mostrarEnConsola('tiendaApiService - getPreciosByIdArtandIdOp', error, 'ERROR')
        })

    },
    getPrecCodStock() {
      this.crearMedida()
      for (var i = 0; i < this.productAux.tallas.length; i++) {
         if (this.productAux.tallas[i].tallaInterna === this.tallaInterna) {
            this.talla = this.productAux.tallas[i].talla
            if (this.productAux.tallas[i].stocks.length > 0) {
              // let stockOp 
              // for (var y = 0; y < this.productAux.tallas[i].stocks.length; y++) {
              //   if (this.productAux.tallas[i].stocks[y].unidades > 0) {
              //     stockOp = this.productAux.tallas[i].stocks[y]
              //     break
              //   }
              // }
              // *** SOLO si queremos que haya stock en la tienda seleccionada ****///
              let stockOp = this.productAux.tallas[i].stocks.find( stock => stock.id.id_op === this.opId )
              if (stockOp) {
                if (stockOp.unidades > 0) {
                  this.unidadesDisp = stockOp.unidades
                } else {
                  this.unidades = 0
                }
                if (stockOp.precio) {
                  this.precio = stockOp.precio.precio
                } else {
                  this.precio = ''
                }

              } else{ 
                this.unidadesDisp = 0
                this.precio = ''
                if (this.precios) {
                  let precioAux = this.precios.find( precio => precio.id.talla_interna == this.productAux.tallas[i].tallaInterna ) 
                  if (precioAux !== undefined) {
                    this.precio = precioAux.precio
                  }
                }
              }
            }
            else {
              this.unidadesDisp = 0
              this.precio = ''
            }
            //sacamos el codigo
            this.codigoEanActual = this.getCodigoEan(this.productAux.tallas[i])
            this.getStockColores()
         }
      }    
    },
    getCodigoEan (talla) {
      let codAux = ''
      if (talla.eans.length > 0) {
        for (var x = 0; x < talla.eans.length; x++) {
          if (!isNaN(talla.eans[x].ean) && talla.eans[x].ean.toString().length === 13) {
            codAux = talla.eans[x].ean
          }
        }
      }
      else {
        //No hay generamos el ean13
        codAux = util.generarEan13(talla.tallaInterna, talla.talla,this.productAux.localizador)
      }
      return codAux
    },
    hayStock(tallaInterna) {
      let medidaAux = this.medidas.find( medida => medida.tallaInterna === tallaInterna )
      // miramos primero si esa talla esta bloqueada
      if (!this.tieneArtbox()) {
        //por configuracion si no tienen artbox entonces no tenemos en cuenta y mostramos siempre
        medidaAux = {}
        medidaAux.bloqueado = 'N'
      }
      if (medidaAux) {
        if (medidaAux.bloqueado==='N') {
          for (var i = 0; i < this.productAux.tallas.length; i++) {
            if (this.productAux.tallas[i].tallaInterna === tallaInterna) {
                if (this.productAux.tallas[i].stocks.length > 0) {
                  for (var y = 0; y < this.productAux.tallas[i].stocks.length; y++) {
                    if (this.productAux.tallas[i].stocks[y].unidades > 0) {
                      return true
                    }
                  }
                  // *** SOLO si queremos que haya stock en la tienda seleccionada ****///
                  //  let stockOp = this.productAux.tallas[i].stocks.find( stock => stock.id.id_op === this.opId ); 
                  //  if (stockOp) {
                  //    if (stockOp.unidades > 0) {
                  //      return true
                  //    } else {
                  //      return false
                  //    }
                  //  } else{ 
                  //    return false
                  //  }
                }
                else {
                  return false
                }
            }
          }
        } else {
          return false
        }
      } else {
        return false
      }   
    },
    /** Función que crea la tabla de stock**/
    getStock() {
      let pass
      this.stock = [[]]
      this.tallas = []
      this.totalTallas =[]
      this.ops = []
      let unidadesReserva =  0
      let reservaAux
      let bloqueado
      for (var i = 0; i < this.productAux.tallas.length; i++) {
        let medidaAux = this.medidas.find( medida => medida.tallaInterna === this.productAux.tallas[i].tallaInterna )
        // miramos primero si esa talla esta bloqueada
         if (!this.tieneArtbox()) {
          //por configuracion si no tienen artbox entonces no tenemos en cuenta y mostramos siempre
          medidaAux = {}
          medidaAux.bloqueado = 'N'
        }
        if (medidaAux) {
          bloqueado = medidaAux.bloqueado
        } else {
          bloqueado = 'S'
        }
        this.tallas.push({'talla' : this.productAux.tallas[i].talla, 'bloqueado' : bloqueado, 'tallaInterna' : this.productAux.tallas[i].tallaInterna })
        this.totalTallas.push({'talla' : this.productAux.tallas[i].talla, 'cantidad' : 0, 'bloqueado' : bloqueado})
        //stock.push(this.productAux.tallas[i].talla)
        this.stock[i] = new Array(this.ops.length)
        for (var y = 0; y < this.productAux.tallas[i].stocks.length; y++) {
          pass = false
          for (var z = 0; z < this.ops.length; z++) {
            if (this.productAux.tallas[i].stocks[y].op !== null) {
              if (this.ops[z] === this.productAux.tallas[i].stocks[y].op.msopclicode) {
                if (this.productAux.tallas[i].stocks[y].unidades > 0) {
                  if (!isNaN(this.stock[i][z])) {
                    this.stock[i][z] = this.stock[i][z] + this.productAux.tallas[i].stocks[y].unidades
                    this.totalTallas[i].cantidad += this.productAux.tallas[i].stocks[y].unidades
                  } else {
                    this.stock[i][z] = this.productAux.tallas[i].stocks[y].unidades
                    this.totalTallas[i].cantidad += this.productAux.tallas[i].stocks[y].unidades
                  }
                  pass = true
                }
              }
            }
          }
          if (!pass) {
            // ahora buscamos si hay stock reservado en la tienda
            if (this.stockReservado.length > 0) {
              reservaAux = this.stockReservado.find(reserva => (reserva.opId === this.productAux.tallas[i].stocks[y].id.id_op && reserva.talla_interna === this.productAux.tallas[i].tallaInterna))
              if (reservaAux) {
                unidadesReserva = reservaAux.unidades
                // console.log(unidadesReserva)
              } else {
                unidadesReserva = 0
              }
            }
            // miramos si la tienda esta en las tiendas del tpv.ini
            let tiendaAux = this.tiendas.find( tienda => tienda.msopid === this.productAux.tallas[i].stocks[y].id.id_op )
            if (tiendaAux) {
              if (this.productAux.tallas[i].stocks[y].unidades > 0) {
                //si la primera talla tiene stock y precio ok la seleccionamos 
                if (this.tallaInterna === '') {
                  this.tallaInterna = this.productAux.tallas[i].tallaInterna
                  if (this.productAux.tallas[i].stocks[y].precio) {
                    this.precio = this.productAux.tallas[i].stocks[y].precio.precio
                  }
                }
                //TEXTURA ponemos primero la tienda almacen y la tienda actual
                if (tiendaAux.msopid === this.opId || tiendaAux.msopid === process.env.VUE_APP_OPIDALMACEN) {
                  this.ops.unshift(this.productAux.tallas[i].stocks[y].op.msopclicode)
                  for (let index = 0; index < this.stock.length; index++) {
                    if (index===i) {
                      this.stock[i].unshift(this.productAux.tallas[i].stocks[y].unidades - unidadesReserva)
                    } else {
                      this.stock[index].unshift('')
                    }       
                  }
                } else {
                  this.ops.push(this.productAux.tallas[i].stocks[y].op.msopclicode)
                  this.stock[i].push(this.productAux.tallas[i].stocks[y].unidades - unidadesReserva)
                }
                this.totalTallas[i].cantidad += this.productAux.tallas[i].stocks[y].unidades - unidadesReserva
              }
            }
          }
        }
      }
      this.mostrarBotones = true
      this.getPrecios()
    },
    getStockColores() {
      if (this.colores.length > 0 && this.tallaInterna !== '') {
        this.stockColores = [[]]
        this.totalColores =[]
        for (var x = 0; x < this.colores.length; x++) {
          this.stockColores[x] = new Array(this.ops.length)
          this.totalColores[x] = 0
          for (var i = 0; i < this.colores[x].tallas.length; i++) {
            if (this.colores[x].tallas[i].tallaInterna === this.tallaInterna) {
              for (var y = 0; y < this.colores[x].tallas[i].stocks.length; y++) {
                if (this.colores[x].tallas[i].stocks[y].op !== null) {
                  const indexOpAux = this.ops.findIndex(element => element == this.colores[x].tallas[i].stocks[y].op.msopclicode)
                  if (indexOpAux !== -1) {
                    if (this.colores[x].tallas[i].stocks[y].unidades > 0) {
                      this.stockColores[x][indexOpAux] = this.colores[x].tallas[i].stocks[y].unidades
                      this.totalColores[x] += this.colores[x].tallas[i].stocks[y].unidades
                    }
                  } else {
                    //no esta la tienda en las ops anteriores de stock, la añadimos
                    if (this.colores[x].tallas[i].stocks[y].unidades > 0) {
                      this.ops.push(this.colores[x].tallas[i].stocks[y].op.msopclicode);
                      this.stockColores[x].push(this.colores[x].tallas[i].stocks[y].unidades);
                      this.totalColores[x] += this.colores[x].tallas[i].stocks[y].unidades
                    }
                  }
                }
                
              }
              break
            }
          }
        }
      }
    },
    getStockReservadoByEansOps () {
      //sacamos los codigos ean para coger el stock reservado
      let codAux = '' 
      for (var i = 0; i < this.productAux.tallas.length; i++) {
        codAux = this.getCodigoEan (this.productAux.tallas[i])
        if (codAux !=='') {
          this.codigosEan.push(codAux)
        }
      }
      let arrTiendaUids = this.tiendas.map(tienda => tienda.msopuid)
      ticketApiService.getStockReservadoByEansOps(this.codigosEan,arrTiendaUids.join(','))
        .then(data => {
          this.stockReservado = data
          // console.log(this.stockReservado)
          this.getMedidas()
        })
        .catch(error => {
          util.mostrarEnConsola('ticketApiService - getStockReservadoByOps', error ,'ERROR')
          this.getMedidas()
        })
    },
    getFotos() {
      if (this.productAux.fotos) {
        this.productAux.fotos.forEach(element =>{
          if (element.porDefecto === "S") {
            if (element.url && !this.isSys4Conjunto()) {
              this.fotos.unshift(element.url)
            } else {
              this.fotos.unshift("data:image/png;base64," + element.imagenBytes)
            }
          } else {
            if (element.url && !this.isSys4Conjunto()) {
              this.fotos.push(element.url)
            } else {
              this.fotos.push("data:image/png;base64," + element.imagenBytes)
            }
          }
        }) 
      } 
    },
    getFotoColores(productAux) {
      let url = ''
      if (productAux.fotos) {
        for (var i = 0; i < productAux.fotos.length; i++) {
          if (productAux.fotos[i].porDefecto === "S") {
            if (productAux.fotos[i].url) {
              url=productAux.fotos[i].url
            } else {
              url= "data:image/png;base64," + productAux.fotos[i].imagenBytes
            }
          } else {
            if (productAux.fotos[i].url) {
              if (url === '') {
                url =  productAux.fotos[i].url
              }
            }
          }
        }
      } 
      if (url === '') {
        return require('@/assets/images/noimg.jpg')
      } else {
        return url
      }
    },
    cambiarArticulo(producto) {
      // document.getElementById('modal-detalle-producto').scrollTo(0,0)
      this.productAux = producto
      this.init()
      this.getColores()
    },
    getColores() {
      tiendaApiService.getColoresByModelo(this.productAux.modelo)
        .then(data => {
          // util.mostrarEnConsola('tiendaApiService - getColoresByModelo', data.length, 'OK')
          // console.log(data)
          this.colores = data 
          this.getStockColores()
        })
        .catch(error => {
          util.mostrarEnConsola('tiendaApiService - getColoresByModelo', error, 'ERROR')
        })
    },
    // toggleColores () {
    //   if (this.mostrarColores) {
    //     this.mostrarColores = false
    //   } else {
    //     this.mostrarColores = true
    //   }
    // },
    getMedidas() {
      tiendaApiService.getMedidasByIdArtic(this.productAux.id)
        .then(data => {
          // util.mostrarEnConsola('tiendaApiService - getMedidasByIdArtic', data.length, 'OK')
          if (data !== "" && data !== null) {
            this.medidas = data
            this.crearMedida()
          }
          this.getStock()
          // console.log(this.medidas)
        })
        .catch(error => {
          util.mostrarEnConsola('tiendaApiService - getMedidasByIdArtic', error, 'ERROR')
          this.getStock()
        })
    },
    crearMedida() {
      let medidaAux = this.medidas.find( medida => medida.tallaInterna === this.tallaInterna )
      if (medidaAux) {
        if (medidaAux.ancho && medidaAux.alto) {
          this.medida = '(' + medidaAux.ancho + ' x ' + medidaAux.alto
          if (medidaAux.fondo) {
            this.medida = this.medida + ' x ' + medidaAux.fondo
          } 
          this.medida = this.medida + ' cm)'
        }
      }
    },
    restar () {
      if (this.cantidad > 1) {
        this.cantidad -= 1
      }
    },
    sumar () {
      this.cantidad += 1
    },
    addToCart () {
      if (this.precio !== '' && this.codigoEanActual !== '' && this.talla !== '' ) {
        this.error = false
        for (var i = 0; i < this.productAux.tallas.length; i++) {
          if (this.productAux.tallas[i].tallaInterna === this.tallaInterna) {
            if (this.cantidad > this.totalTallas[i].cantidad) {
              this.error = true
              this.$root.$emit('mostrarAlerta', 'No hay suficiente stock', 'error')
            } else {
              Object.assign(this.productAux, {stock: this.totalTallas[i].cantidad})
            }
            break
          }
        }
        if (!this.error) {
          Object.assign(this.productAux, {cantidad: this.cantidad})
          Object.assign(this.productAux, {codigo: this.codigoEanActual})
          Object.assign(this.productAux, {precio: this.precio})
          Object.assign(this.productAux, {talla: this.talla})
          Object.assign(this.productAux, {foto: this.fotos[0]})
          this.$store.commit('addToCart', this.productAux)
          this.$emit('cerrar')
        }
      } else {
        this.$root.$emit('mostrarAlerta', 'Ha ocurrido un error', 'error')
        console.log(this.codigoEanActual + " " + this.precio + " " + this.talla)
      }
    },
    getLikeList() {
      this.likeList = this.$store.getters.getLikeList
      const r = this.likeList.some(producto => producto.idArtic == this.productAux.id);
      this.isInLikeList = r
    },
    addToLikeList() {
      if (!this.isInLikeList) {
        tiendaApiService.addToLikeList(this.$store.getters.getCliente.id, this.productAux.id)
          .then(data => {
            if (data) {
              this.$store.commit('addToLikeList', this.productAux.id)
              this.isInLikeList = true
            } else {
              this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
            }
          })
          .catch(error => {
            this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
            console.log(error)
          })
      } else {
        tiendaApiService.deleteFromLikeList(this.$store.getters.getCliente.id, this.productAux.id)
            .then(data => {
              if (data) {
                this.$store.commit('deleteFromLikeList', this.productAux.id)
                this.isInLikeList = false
              } else {
                this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
              }
            })
            .catch(error => {
              console.log(error)
            })
      }
    },
    addToHistorial() {
      tiendaApiService.addToHistorial(this.$store.getters.getCliente.id, this.productAux.id)
        .then(data => {
          if (!data) {
            // this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    abrirControlStock (clicode, num) {
      if (this.permitido('MOBILESTORE.TIENDA.MOVSTOCK')) {
        this.mostrarControlStock = true
        this.controlStock = num
        this.movStock = num
        if (clicode === this.tiendas[0].msopclicode) {
          //la tienda que manda es la nuestra
          this.store1 = this.tiendas[0].msopuid
          if (this.tiendas.length > 1) {
            this.store2 = this.tiendas[1].msopuid
          }
          this.store1RO = true
          this.store2RO = false
        } else {
          //solicitamos stock a tora tienda
          this.store1RO = false
          this.store2RO = true
          this.store2 = this.tiendas[0].msopuid
          this.store1 = this.tiendas.find(element => element.msopclicode == clicode).msopuid
        }
      }
    },
    selecStock(item, unidades) {
      this.unidadesMov = unidades
      
    },
    sumarStock () { 
      if (this.movStock < this.controlStock) {
        this.movStock = this.movStock + 1
      }
    },
    restarStock () {
      if (this.movStock > 0) {
        this.movStock = this.movStock - 1
      }
    },
    guardarControlStock () {
      this.$root.$emit('mostrarAlerta', this.$t('lang.detalleProducto.stocksolicitado'), 'info')
      this.mostrarControlStock = false
    },

    /**
     * de momento no hay funcionalidad de wish list solo de likes
     */
    // getWishLists() {
    //   this.wishLists = this.$store.getters.getWishLists
    //   const r = this.wishLists.some(d => d.productos.some(producto => producto.idArticulo == this.productAux.id));
    //   this.isInWishList = r
    // },
    // addToWishList() {
    //   if (!this.isInWishList) {
    //     if (this.wishLists.length > 0) {
    //       tiendaApiService.addToWishList(this.wishLists[this.wishLists.length - 1].id, this.productAux.id)
    //         .then(data => {
    //           this.$store.commit('addToWishList', this.productAux)
    //           this.isInWishList = true
    //         })
    //         .catch(error => {
    //           console.log(error)
    //         })
    //     } else {
    //       //TODO: Crear una wishlist
    //     }
    //   } else {
    //     tiendaApiService.deleteFromWishList(this.wishLists[this.wishLists.length - 1].id, this.productAux.id)
    //         .then(data => {
    //           this.$store.commit('deleteFromWishList', this.productAux)
    //           this.isInWishList = false
    //         })
    //         .catch(error => {
    //           console.log(error)
    //         })
    //   }
    // },
    formatMoney (num) {
      return util.formatMoney(num)
    }
  }
};
</script>

